var _circle, _circle2, _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 49.5,
    r: 44.5,
    fill: "white",
    stroke: "url(#paint0_linear_2_110)",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3681,
    cy: 38.8407,
    r: 10.1264,
    fill: "url(#paint1_linear_2_110)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.0879,
    y: 38.3077,
    width: 3.1978,
    height: 13.8571,
    fill: "url(#paint2_linear_2_110)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6154,
    y: 43.6374,
    width: 3.1978,
    height: 13.8571,
    transform: "rotate(90 75.6154 43.6374)",
    fill: "url(#paint3_linear_2_110)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6913 59.6707V70.2857H47.1699L27.6484 70.2857V59.6707C28.3592 58.9645 29.144 58.2938 29.9993 57.6651C34.5532 54.3179 40.7297 52.4375 47.1699 52.4375C53.6101 52.4375 59.7865 54.3179 64.3404 57.6651C65.1957 58.2938 65.9806 58.9645 66.6913 59.6707Z",
    fill: "url(#paint4_linear_2_110)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_110",
    x1: 49.5,
    y1: 1,
    x2: 49.5,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B90D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_110",
    x1: 47.3681,
    y1: 28.7143,
    x2: 47.3681,
    y2: 48.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_110",
    x1: 68.6868,
    y1: 38.3077,
    x2: 68.6868,
    y2: 52.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_110",
    x1: 77.2143,
    y1: 43.6374,
    x2: 77.2143,
    y2: 57.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_110",
    x1: 47.1698,
    y1: 52.4375,
    x2: 47.1698,
    y2: 70.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242B65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/create-account.c3b8c5e818bde85934e04f3e6c680b4b.svg";
export { ForwardRef as ReactComponent };